import { defineStore } from "pinia";
import { auth, db } from "../plugins/firebase";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";
import router from "../router";
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
    role: null,
    businessId: null,
    resellerId: null,
    users: [],
    loading: true,
    error: null,
  }),

  actions: {
    // ✅ Initialize authentication state
    async init() {
      onAuthStateChanged(auth, async (firebaseUser) => {
        console.log("🔥 Firebase Auth State Changed:", firebaseUser);
        if (firebaseUser) {
          this.user = {
            uid: firebaseUser.uid,
            email: firebaseUser.email,
          };
          console.log("✅ User logged in:", this.user);
          await this.fetchUserRole(firebaseUser.uid);
        } else {
          this.user = null;
          this.role = null;
          this.businessId = null;
          this.resellerId = null;
        }
        this.loading = false;
      });
    },

  // ✅ Fetch users from Firestore and update store
async fetchUsers() {
  try {
    console.log("Fetching users...");
    const querySnapshot = await getDocs(collection(db, "users"));

    this.users = querySnapshot.empty
      ? []
      : querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

    console.log("Users fetched:", this.users);
  } catch (error) {
    console.error("Error fetching users:", error);
    this.users = []; // ✅ Ensure users is always an array
  }
},

    // ✅ Fetch user role from Firestore
   async fetchUserRole(uid) {
  try {
    const userDoc = await getDoc(doc(db, "users", uid));
    if (!userDoc.exists()) {
      console.warn("User not found in Firestore. Using default role.");
      this.role = "User"; // Default role
      this.businessId = null;
      this.resellerId = null;
      return;
    }

    const { role = "User", businessId = null, resellerId = null } = userDoc.data();
    this.role = role;
    this.businessId = businessId;
    this.resellerId = resellerId;
  } catch (error) {
    console.error("Error fetching user role:", error);
    this.role = "User"; // Default fallback
        this.businessId = null;
        this.resellerId = null;
      }
    },

// ✅ User login
async login(email, password) {
      try {
        this.error = null;
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        this.user = {
          uid: userCredential.user.uid,
          email: userCredential.user.email,
        };

        console.log("User set in store:", this.user);
        console.log("User role set in store:", this.role);
        await this.fetchUserRole(userCredential.user.uid);

        router.push({ name: "dashboard" });

        return userCredential;
      } catch (error) {
        console.error("Login error:", error);
        this.error = error.message || error;
        throw error;
      }
    },

    // ✅ User logout
    async logout() {
      try {
        await signOut(auth);
        this.user = null;
        this.role = null;
        this.businessId = null;
        this.resellerId = null;
        this.users = [];
      } catch (error) {
        console.error("Logout error:", error);
        throw error;
      }
    },
  },
});